const CONNECTION_ACTIONS = Object.freeze({
    ACCEPT: 'accept',
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected',
    REQUEST: 'request',
    UNAVAILABLE: 'unavailable',
    WAITING: 'waiting'
});

const getConnectionAction = ({ isMe, user, roleInteraction }) => {

    if (!user || isMe || !user.enabled || !roleInteraction?.canViewProfile) {
        return CONNECTION_ACTIONS.UNAVAILABLE;
    }

    switch (user.peerStatus) {
        case 'accepted':
            return CONNECTION_ACTIONS.CONNECTED;
        case 'pending':
            return CONNECTION_ACTIONS.ACCEPT;
        case 'waiting':
        case 'declinedByThem':
            return CONNECTION_ACTIONS.WAITING;
        case 'declinedByMe':
            return CONNECTION_ACTIONS.DISCONNECTED;
        case null:
        case undefined:
            return CONNECTION_ACTIONS.REQUEST;
        default:
            return CONNECTION_ACTIONS.UNAVAILABLE;
    }
};

module.exports = {
    CONNECTION_ACTIONS,
    getConnectionAction
};
